<div class="dicom-banner" *ngIf="esDeDicom">
  <div class="banner-content">
    <mat-icon class="banner-icon">report_problem</mat-icon>
    <div class="banner-text">
      <strong>Paciente creado desde un estudio de imágenes -</strong>
      <span *ngIf="faltantes.length > 0">
        Faltan completar:
        <strong *ngFor="let campo of faltantes; let last = last"
          >{{ campo }}<span *ngIf="!last">, </span></strong
        >
      </span>
      <span *ngIf="faltantes.length === 0">Los datos están completos.</span>
    </div>
    <button mat-button color="primary" type="button" (click)="fusionar.emit()">
      Este paciente ya existe
    </button>
  </div>
</div>
